module.exports = __webpack_public_path__ + "media/icons/naped-4x4-blue@3x-db6d6a38.svg";